/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getPaymentRewardStatus} from '../api'

 export const useQueryGetPaymentRewardStatus = createReactQueryHook('getPaymentRewardStatus', getPaymentRewardStatus)
